import { supabase } from "../supabase/client";
import { useState, useRef, useEffect } from "react";
import { useUser } from "../context/Usercontext";
import Button from "../minicomponents/Button";
import SettingsArea from "./SettingsArea";

let LeftBox = function ({ handleTesting, singOut }) {
  let { user, setUser } = useUser();
  return (
    <div className="main-profile-box-left">
      <div className="main-profile-box-left-single-flex">
        <div className="large-photo-profile">
          <img src="https://images.unsplash.com/photo-1673861561475-e0415df68554?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80" />
        </div>
        <img className="profile-picture-user" src={user.profile_pic} />
        <span className="profile-box-left-name-user">{user.full_name} </span>
        <span className="profile-box-left-username">{user.username} </span>
        <span className="profile-box-left-quote">Don't give a shit 😂⏰</span>
      </div>
      <SettingsArea />
      <div className="main-profile-box-left-single-flex">
        <button onClick={handleTesting}>Test</button>
        <Button
          buttonStyle={"button-style-2 button-width-100"}
          onPress={singOut}
        >
          Salir
        </Button>
      </div>
    </div>
  );
};

export default LeftBox;
